export default {
    bannersBackground: () => {
        if (typeof document !== 'undefined' && typeof window !== 'undefined') {
            const pageBuilderBanners = document?.querySelectorAll('.pagebuilder-banner-wrapper')
            Array.from(pageBuilderBanners).forEach((el: any) => {
                const dataBackgroundImages = el?.getAttribute('data-background-images')
                const correctedString = dataBackgroundImages?.replace(/\\"/g, '"')
                const data = JSON.parse(<string>correctedString)
                const desktop = data?.desktop_image
                const mobile = data?.mobile_image
                const image = window.innerWidth <= 768 ? mobile : desktop
                const elHeight = el?.offsetHeight
                el.style.background = `url('https://${window.location.hostname}${`/_next/image?url=${image}&w=${1440}&h=${elHeight}&q=85`}')`
            })
        }
    }
}